import { createFileRoute, notFound } from '@tanstack/react-router';
import { isUuid } from '@leanin/shared';
import { BroadcastDetailView } from '@/components/broadcasts/BroadcastDetailView';
import { AdminShell } from '@/components/admin/AdminShell';
import { PLATFORM_ADMIN_ITEMS } from '@/components/admin/admin-sidebar-items';

export const Route = createFileRoute('/_authed/admin/broadcasts/$id/')({
  beforeLoad: ({ params }) => {
    if (!isUuid(params.id)) throw notFound();
  },
  component: BroadcastReviewPage,
});

function BroadcastReviewPage() {
  const { id } = Route.useParams();
  return (
    <AdminShell items={PLATFORM_ADMIN_ITEMS} active="broadcasts">
      <BroadcastDetailView
        scope={{ kind: 'platform' }}
        broadcastId={id}
      />
    </AdminShell>
  );
}
